module.exports = __webpack_public_path__ + "static/img/our-awards_6.f69cd8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/our-awards_6.png
// module id = 5ETe
// module chunks = 0